import * as _ from "lodash";
import { Components } from "formiojs";
import { ValidationPatterns } from "@bbwt/modules/validation";

const TextFieldComponent = Components.components.textfield;

export default class MiproClinicianPhoneField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproClinicianPhoneField",
            label: "Clinician Phone",
            key: "dbo.mipro.miproClinicianPhone",
            placeholder: "Enter Clinician Phone", 
            disabled: false, 
            input: true,
            validate: {
                 custom: `valid = (!input || !!input.match(/${ValidationPatterns.phone}/)) ? true : "Invalid phone number";`
            }
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Clinician Phone Number",
            group: "basic",
            icon: "phone",
            weight: 70,
            schema: MiproClinicianPhoneField.schema(),            
        };
    }
}

Components.addComponent("miproClinicianPhoneField", MiproClinicianPhoneField);